module.exports = __webpack_public_path__ + "fonts/montserrat-regular-webfont.14433da.woff2";